export const DEMO_QUESTION = 'What can Henry’s memories tell us about him?';
// The pointer, streamed answer and both device previews share these beats.
export const HOME_DEMO_TIMING = {
  typingAt: 1100, typingDuration: 1900, submitAt: 3500,
  answerAt: 6300, answerCompleteAt: 8700, answerScrollAt: 9000,
  composeAt: 10600, readingAt: 12700, coverScrollAt: 14300,
  visitClickAt: 16600, visitAt: 16900, endAt: 20500,
};
export const DEMO_DURATION = { home: HOME_DEMO_TIMING.endAt, palette: 14100, gallery: 38000, exhibition: 25000, 'access-home': 10300, 'access-header': 7600, 'access-sidebar': 9600, 'access-gallery': 20600, 'access-exhibition': 25000 };
export function exhibitionDemoTiming(scene, touch = false) {
  return scene === 'access-exhibition' && touch
    ? { beginAt: 1800, stepDuration: 5000, duration: 21400 }
    : { beginAt: 4200, stepDuration: 5500, duration: 25000 };
}
export function archiveDemoDuration(scene, touch = false) {
  return scene === 'access-exhibition' ? exhibitionDemoTiming(scene, touch).duration : DEMO_DURATION[scene];
}
export const VIEW_READING_AT = HOME_DEMO_TIMING.readingAt;
export const VIEW_VISIT_AT = HOME_DEMO_TIMING.visitAt;
export const PALETTE_OPEN_AT = 1100;
export const PALETTE_MODE_DURATION = 3200;

// Both Gallery previews visit the production stations on one clock. Travel
// and dwell are separate so a slower-loading device never skips a stop.
export const GALLERY_DEMO_STOPS = [
  { at: 0, travel: 1800, area: 'hall', angle: 'front' },
  { at: 3200, travel: 1600, area: 'hall', angle: 'across' },
  { at: 6000, travel: 1800, area: 'directory' },
  { at: 10800, travel: 1800, area: 'collection' },
  { at: 15600, travel: 1800, area: 'compose' },
  { at: 20400, travel: 1800, area: 'archive' },
  { at: 25200, travel: 2400, area: 'about' },
  { at: 32400, travel: 2400, area: 'hall', angle: 'front' },
];

// A shorter visit demonstrates the responsive collection and entrance panels.
export const ACCESS_GALLERY_STOPS = [
  { at: 0, travel: 1800, area: 'hall', angle: 'across' },
  { at: 3400, travel: 1800, area: 'directory' },
  { at: 11000, travel: 1800, area: 'collection' },
  { at: 16800, travel: 1800, area: 'hall', angle: 'across' },
];

// The opening demonstration keeps desktop and phone in step. The device study
// can use shorter touch introductions without changing that original sequence.
export function archiveDemoState(scene, elapsed, touch = false) {
  const time = Math.max(0, Math.min(elapsed, archiveDemoDuration(scene, touch)));
  if (scene === 'access-home') return { ...archiveDemoState('home', time), caption: 'Ask a question directly on Home.' };
  if (scene === 'access-header' || scene === 'access-sidebar') return {
    time, phase: 'access', mode: 'search', open: time >= (scene === 'access-sidebar' ? 5800 : 3600), modeMenu: false,
    caption: scene === 'access-header' ? 'Open Search, Ask, View and the map from the header.' : 'On a wide screen, search stays beside the page. On a phone, it stays in the header.',
  };
  if (scene === 'exhibition') return {time, phase:'reading', mode:'', open:false, modeMenu:false, caption:'Walk through an exhibition.'};
  if (scene === 'access-exhibition') {
    const { beginAt, stepDuration } = exhibitionDemoTiming(scene, touch);
    return { time, phase: 'reading', mode: '', open: false, modeMenu: false,
      visitStep: Math.max(-1, Math.floor((time - beginAt) / stepDuration)), caption: 'Walk through an exhibition.' };
  }
  if (scene === 'gallery' || scene === 'access-gallery') {
    const stops = scene === 'access-gallery' ? ACCESS_GALLERY_STOPS : GALLERY_DEMO_STOPS;
    const stopIndex = stops.findLastIndex(stop => time >= stop.at);
    const stop = stops[stopIndex];
    return { time, phase: 'gallery', mode: '', open: false, modeMenu: false,
      stopIndex, stop, previousStop: stops[stopIndex - 1], arrived: time >= stop.at + stop.travel,
      directoryExpanded: scene === 'access-gallery' && time >= 6900 && time < 11000,
      caption: 'Explore the Gallery.',
    };
  }
  if (scene === 'palette') {
    const relative = Math.max(0, time - 1300);
    const index = Math.min(3, Math.floor(relative / PALETTE_MODE_DURATION));
    const mode = ['search', 'ask', 'view', 'map'][index];
    return { time, mode, phase: 'palette', typed: '', open: time >= PALETTE_OPEN_AT,
      modeMenu: time >= 1300 && index < 3 && relative % PALETTE_MODE_DURATION >= 2600,
      caption: time < PALETTE_OPEN_AT ? 'Open the search panel from any page.' : {
        search: 'Find a passage in its original context.', ask: 'Read an answer with its sources.',
        view: 'Choose a perspective for a View.', map: 'Explore connections across the archive.',
      }[mode],
    };
  }
  const timing = HOME_DEMO_TIMING;
  const phase = time < timing.typingAt ? 'home' : time < timing.submitAt ? 'typing'
    : time < timing.answerAt ? 'thinking' : time < timing.composeAt ? 'answer'
      : time < VIEW_READING_AT ? 'composing' : 'reading';
  return { time, phase, mode: '', open: false, modeMenu: false,
    atEntrance: time >= VIEW_VISIT_AT,
    answerProgress: Math.max(0, Math.min(1, (time - timing.answerAt) / (timing.answerCompleteAt - timing.answerAt))),
    typed: DEMO_QUESTION.slice(0, Math.floor(DEMO_QUESTION.length * Math.max(0, Math.min(1, (time - timing.typingAt) / timing.typingDuration)))),
    caption: { home: 'Start with a question on Home.', typing: 'Ask about what interests you.',
      thinking: 'Finding relevant parts of the site.', answer: 'Read the answer, then explore the story.',
      composing: 'The question becomes a View.', reading: 'Explore the View.',
    }[phase],
  };
}
